// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"e71862e3","673":"2349d7ae","926":"757b0824"}[chunkId] + ".chunk.css";
};